import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 9.8rem 0 9.8rem 0;

  .content_wrapper {
    gap: 1rem;
    display: flex;
    padding: 1.5rem;
    margin: 0 4rem 0 0;
    align-items: center;
    background: #FFEEE3;
    justify-content: center;

    @media (max-width: 820px) {
      margin: 1rem;
    }
  }

  .left {
    align-self: flex-start;

    svg {
      margin: .3rem 0 0 0;
    }
  }

  .right {

    h1 {
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      color: #F07E35;
    }

    p {
      color: #F07E35;
      font-size: 19px;
      font-style: normal;
      font-weight: 400;
      line-height: 130%
    }

    p:nth-child(2) {
      margin: 1rem 0 0 0;
    }


  }
`;